import {
  VideoCameraIcon,
  VideoCameraSlashIcon,
  MicrophoneIcon,
  ComputerDesktopIcon,
  UserGroupIcon,
  Cog6ToothIcon,
  PhoneXMarkIcon
} from '@heroicons/react/24/outline'
import { WherebyToolbarButtonId } from '../../../../../../pure-js/enums/Whereby'

type HeroIcon = typeof VideoCameraIcon

export interface WherebyToolbarButtonConfig {
  id: WherebyToolbarButtonId
  translationKey: string
  icon: HeroIcon
  mutedIcon?: HeroIcon
  variant?: 'default' | 'destructive'
}

export const WHEREBY_TOOLBAR_BUTTONS: WherebyToolbarButtonConfig[] = [
  {
    id: WherebyToolbarButtonId.CAMERA,
    translationKey: 'whereby.toolbar.camera',
    icon: VideoCameraIcon,
    mutedIcon: VideoCameraSlashIcon
  },
  {
    id: WherebyToolbarButtonId.MICROPHONE,
    translationKey: 'whereby.toolbar.microphone',
    icon: MicrophoneIcon
  },
  {
    id: WherebyToolbarButtonId.SCREENSHARE,
    translationKey: 'whereby.toolbar.screenShare',
    icon: ComputerDesktopIcon
  },
  {
    id: WherebyToolbarButtonId.PEOPLE,
    translationKey: 'whereby.toolbar.people',
    icon: UserGroupIcon
  },
  {
    id: WherebyToolbarButtonId.SETTINGS,
    translationKey: 'whereby.toolbar.settings',
    icon: Cog6ToothIcon
  },
  {
    id: WherebyToolbarButtonId.LEAVE,
    translationKey: 'whereby.global.leaveCall',
    icon: PhoneXMarkIcon,
    variant: 'destructive'
  }
]

const MEDIA_TOGGLE_BUTTON_IDS = new Set<string>([WherebyToolbarButtonId.CAMERA, WherebyToolbarButtonId.MICROPHONE])

/** The camera and the microphone: buttons that are on or muted rather than pressed. */
export const isMediaToggleButton = (id: string): boolean => MEDIA_TOGGLE_BUTTON_IDS.has(id)
